import React from 'react'

const SolBig = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="51"
            height="50"
            fill="none"
            viewBox="0 0 51 50"
        >
            <circle cx="25.002" cy="25" r="25" fill="#000"></circle>
            <path
                fill="url(#paint0_linear_1_1586)"
                d="M15.5 30.923a.94.94 0 01.663-.275h22.912a.47.47 0 01.332.802l-4.526 4.526a.94.94 0 01-.664.274H11.305a.47.47 0 01-.332-.801l4.526-4.526z"
            ></path>
            <path
                fill="url(#paint1_linear_1_1586)"
                d="M15.5 14.024a.966.966 0 01.663-.274h22.912a.47.47 0 01.332.801l-4.526 4.526a.939.939 0 01-.664.274H11.305a.47.47 0 01-.332-.8l4.526-4.527z"
            ></path>
            <path
                fill="url(#paint2_linear_1_1586)"
                d="M34.88 22.42a.939.939 0 00-.663-.275H11.305a.47.47 0 00-.332.801l4.526 4.526a.94.94 0 00.664.275h22.912a.47.47 0 00.332-.802L34.88 22.42z"
            ></path>
            <defs>
                <linearGradient
                    id="paint0_linear_1_1586"
                    x1="-40.949"
                    x2="-41.559"
                    y1="9.499"
                    y2="40.174"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#00FFA3"></stop>
                    <stop offset="1" stopColor="#DC1FFF"></stop>
                </linearGradient>
                <linearGradient
                    id="paint1_linear_1_1586"
                    x1="-47.883"
                    x2="-48.492"
                    y1="5.88"
                    y2="36.554"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#00FFA3"></stop>
                    <stop offset="1" stopColor="#DC1FFF"></stop>
                </linearGradient>
                <linearGradient
                    id="paint2_linear_1_1586"
                    x1="-44.438"
                    x2="-45.048"
                    y1="7.678"
                    y2="38.353"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#00FFA3"></stop>
                    <stop offset="1" stopColor="#DC1FFF"></stop>
                </linearGradient>
            </defs>
        </svg>
    )
}

export default SolBig